import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";
import {IoCopyOutline} from "react-icons/io5";

export const renderCourseSubject = ({ detail = true, renderActions = NullAsDefault, handleAction = (() => {})} = {}) => (item, index) => {
    const {subject, is_linked, number_of_credits, number_of_sessions, is_mandatory} = item ?? {}
    const {description, subject_idcode} = subject ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <div className="p-3 flex flex-col gap-1 border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative">
                    <div className="font-bold text-sm md:text-base text-gray-800 no-underline">
                        {getTitle(subject)}
                    </div>
                    <div className="flex flex-col gap-y-1">
                        {renderIf(
                            is_mandatory === 1,
                            <span className="text-xs text-primary-400 italic">
                                {`* ${t('is mandatory subject')}`}
                            </span>
                        )}
                        <ItemInformation
                            showIcon={true}
                            label="subjects"
                            value={
                                <span className="font-semibold text-color-200 hover:text-color-000 italic cursor-pointer"
                                      onClick={() => {
                                          copyToClipboard(subject_idcode)
                                          message.success(t('copied'))
                                      }}>
                                    {subject_idcode}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                </span>
                            }
                            className="text-xs italic"
                        />
                    </div>
                    {renderIf(
                        is_linked,
                        <div className="flex flex-col gap-y-1">
                            <ItemInformation showIcon={true} label="number of sessions" value={`${number_of_sessions} ${t('sessions')}`} className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="number of credits" value={`${number_of_credits} ${t('credits')}`} className="text-xs italic"/>
                        </div>
                    )}
                    {renderIf(
                        description,
                        <div className="text-sm text-color-300 max-lines-3">{description}</div>
                    )}
                    {renderActions(item)}
                </div>
            )}
        </Translate>
    )
}
